export class User {
    id: number;
    user_name: string;
    password: string;
    agency_name: string;
    last_name: string;
    first_name: string;
    address1: string;
    address2: string;
    city: string;
    state: string;
    zip: number;
    email: string;
    phone: string;
    fax: string;
    level: number;
    is_agree: boolean;
    is_active: boolean;
    last_logged_in: string;
    created: string;
    pcc?: string;

    constructor(id: number, user_name: string, password: string, agency_name: string, last_name: string, first_name: string,
                address1: string, address2: string, city: string, state: string, zip: number,
                email: string, phone: string, fax: string,
                level: number, is_agree: boolean, is_active: boolean,
                last_logged_in: string, created: string) {
        this.id = id;
        this.user_name = user_name;
        this.password = password;
        this.agency_name = agency_name;
        this.last_name = last_name;
        this.first_name = first_name;
        this.address1 = address1;
        this.address2 = address2;
        this.city = city;
        this.state = state;
        this.zip = zip;
        this.email = email;
        this.phone = phone;
        this.fax = fax;
        this.level = level;
        this.is_agree = is_agree;
        this.is_active = is_active;
        this.last_logged_in = last_logged_in;
        this.created = created;
    }
}

export class UserCreate {

    user_name: string;
    password: string;
    agency_name: string;
    last_name: string;
    first_name: string;
    address1: string;
    address2: string;
    city: string;
    state: string;
    zip: number;
    email: string;
    phone: string;
    fax: string;
    level: number;
    is_agree: boolean;
    is_active: boolean;

    constructor(user_name: string, password: string, agency_name: string, last_name: string, first_name: string,
                email: string, phone: string,
                level: number, is_agree: boolean, is_active: boolean,
                address1?: string, address2?: string, city?: string, state?: string, zip?: number, fax?: string) {

        this.user_name = user_name;
        this.password = password;
        this.agency_name = agency_name;
        this.last_name = last_name;
        this.first_name = first_name;
        this.address1 = address1;
        this.address2 = address2;
        this.city = city;
        this.state = state;
        this.zip = zip;
        this.email = email;
        this.phone = phone;
        this.fax = fax;
        this.level = level;
        this.is_agree = is_agree;
        this.is_active = is_active;

    }
}

export class UserLogin {
    constructor(
        public user_name: string,
        public id: number,
        public level: number,
        private _token: string,
        private _tokenExpirationDate: Date
    ) {
    }

    get token() {
        if (!this._tokenExpirationDate || new Date() > this._tokenExpirationDate) {
            return null;
        }
        return this._token;
    }
}
